module.exports = __webpack_public_path__ + "img/telegram.1f603699.svg";